module.exports = __webpack_public_path__ + "static/media/xnk.5eac7c5a.png";